import { handleAuthResponse } from '../auth';

const API_URL = process.env.REACT_APP_API_URL;

export const getPoll = (groupId) => {
    return fetch(`${API_URL}/poll/${groupId}`, {
        method: 'GET',
        credentials: 'include',
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || 'Network error' }; });
};

export const createOrUpdatePoll = (groupId, data) => {
    return fetch(`${API_URL}/poll/${groupId}`, {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify(data),
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || 'Network error' }; });
};

export const addCandidate = (groupId, name) => {
    return fetch(`${API_URL}/poll/${groupId}/candidate`, {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ name }),
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || 'Network error' }; });
};

export const removeCandidate = (groupId, name) => {
    return fetch(`${API_URL}/poll/${groupId}/candidate`, {
        method: 'PUT',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ name }),
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || 'Network error' }; });
};

export const togglePoll = (groupId, open) => {
    return fetch(`${API_URL}/poll/${groupId}/toggle`, {
        method: 'PUT',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ open }),
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || 'Network error' }; });
};

export const castVote = (groupId, candidate, voterName) => {
    return fetch(`${API_URL}/poll/${groupId}/vote`, {
        method: 'POST',
        headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
        credentials: 'include',
        body: JSON.stringify({ candidate, voterName }),
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || 'Network error' }; });
};

export const resetPoll = (groupId) => {
    return fetch(`${API_URL}/poll/${groupId}`, {
        method: 'DELETE',
        credentials: 'include',
    })
        .then(handleAuthResponse)
        .catch(err => { console.log(err); return { error: err.message || 'Network error' }; });
};
